const LogResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'logs/',
        apiRequestParams.defaults(),
        {
            storeIntegratedPaymentLog: {
                url: appConfig.apiBaseUrl + 'logs/integrated-payments',
                method: 'POST',
            },
        }
    );
};

module.exports = LogResource;
